import React, { useEffect, useState } from "react";
import { getAPI, postAPI } from "./api/callAPI";
import { isArray } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import {
  setEndPoint,
  setStoreData as setStore,
  //   setUserLocation,
} from "../src/redux/action";
import { useNavigate, useLocation } from "react-router";
import { CircularProgress, Container } from "@mui/material";
import { useThemeColor } from "./hooks/useThemeColor";
import { resolveEndpoint } from "./Common/utils";

const StoreCheck = ({ children }) => {
  const { updateThemeColor } = useThemeColor();
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  //   const [storeList, setStoreList] = useState([]);
  const [apiLoading, setApiLoading] = useState(false);
  const { endpoint } = useSelector((state) => state.auth);

  const loadStore = async (endpoint1, singleStoreID, isSingleStore = true) => {
    try {
      const resp = await getAPI(endpoint1, `stores/${singleStoreID}`);
      // console.log("loadStore resp >>> ", resp);
      if (resp?.success) {
        if (isArray(resp?.data?.design_config)) {
          const primaryColor = resp?.data?.design_config?.find((item) => item?.item_name === "primary");
          // console.log("primaryColor >>> ", primaryColor);
          if (primaryColor?.item_value) {
            updateThemeColor(primaryColor?.item_value);
          }
        }

        if (isSingleStore) {
          if (resp?.data["0"]) {
            const storeSlug = resp?.data["0"]?.slug;
            dispatch(setStore(resp?.data["0"]));
            
            // Only navigate if we're on the home page or not on a valid store route
            // Don't redirect if already on a valid route like /web/:storeSlug/book-a-table
            const currentPath = location.pathname;
            const isHomePage = currentPath === '/';
            const isStoreRoute = currentPath.startsWith('/web/');
            
            if (isHomePage || !isStoreRoute) {
              navigate(`/web/${storeSlug}`);
            }
            // navigate(`/web/${singleStoreID}/book-a-table`);
          }
        }
      } else {
        dispatch(setStore({}));
        // navigate(`/web/${singleStoreID}/book-a-table`);
      }
    } catch (error) {
      console.error("loadSingleStore error >>> ", error);
      dispatch(setStore({}));
    }
  };

  const handleMultiStore = async (storeList) => {
    // if (isArray(storesList) && storesList.length > 0) {
    // const mainStore = find(storesList, (item) => item?.id === 1);
    loadStore(endpoint, 1, false);
    // if (mainStore) {
    //   dispatch(setStore(mainStore));
    //   // navigate(`/web/${mainStore?.id}/book-a-table`);
    // }
    // }
  }

  const checkStore = async (endpoint1) => {
    setApiLoading(true);
    try {
      // const mResp = await getAPI(endpoint1, "admin/get-active-store-for-admin");
      const mResp = await postAPI(
        endpoint1,
        "stores-list-by-text-and-lat-long"
      );
      // console.log("mResp >>> ", mResp);
      if (mResp?.success) {
        if (isArray(mResp?.data) && mResp.data.length > 0) {
          const storesList = mResp.data;
          if (storesList.length === 1) {
            const singleStoreID = storesList[0]?.id;
            // const resp = await getAPI(endpoint1, `stores/${singleStoreID}`);
            // console.log("resp >>> ", resp);
            // setstoreData(resp?.data["0"]);
            // setStoreData(resp?.data["0"]);
            // dispatch(setStore(resp?.data["0"]));
            // navigate(`/web/${singleStoreID}/book-a-table`);
            loadStore(endpoint1, singleStoreID, true);
          } else {
            // multistore
            // setStoreData(resp?.data["0"]);
            // dispatch(setStore(resp?.data["0"]));
            // final
            // setStoreList(mResp?.data);
            handleMultiStore(storesList);
          }
        } else {
          dispatch(setStore({}));
        }
      }
      setApiLoading(false);
    } catch {
      dispatch(setStore({}));
      setApiLoading(false);
    }
  };

  useEffect(() => {
    const resolved = resolveEndpoint();
    dispatch(setEndPoint(resolved));
    checkStore(resolved);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (apiLoading) {
    return (
      <Container maxWidth="lg">
        <CircularProgress variant="indeterminate" />
      </Container>
    );
  }

  // if (typeof storeData == "object" && !Object.keys(storeData).length) {
  //   return <NotFound />;
  // }

  return children;
};

export default StoreCheck;
